export default "__VITE_ASSET__3f5fc727__"